<template>
  <div class="VStack flex" v-bind="$attrs">
    <div
      class="flex flex-col w-full"
      :class="[...classes, margin && '-w-m']"
      :style="createStyle({ '--child-margin': margin })"
    >
      <slot></slot>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { useMargin, type StackingProps, useStackingClasses } from './utils'
import { createStyle } from '/@/utils/misc'

export default defineComponent({
  props: {
    spacing: [String, Number],
    fill: Boolean,
    align: String,
  },
  setup(props) {
    const margin = useMargin(props as StackingProps)
    const classes = useStackingClasses(props as StackingProps)

    return {
      createStyle,
      margin,
      classes,
    }
  },
})
</script>

<style lang="scss">
.VStack {
  width: inherit;
  height: inherit;

  &.-fill {
    flex: 1;
  }

  > div {
    flex: inherit;
    --child-margin: 0;

    &.-w-m {
      > * + * {
        margin-top: var(--child-margin);
      }
    }
  }
}
</style>
